<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<section id="wrapper" class="error-page">
    <div class="error-box">
        <div class="error-body text-center">
            <h1>404</h1>
            <!--               <h3 class="text-uppercase">HA UPEI !!!</h3>
     -->
            <p class="text-muted m-t-30 m-b-30">Ruta no encontrada</p>
            <a routerLink="/login" class="btn btn-info btn-rounded waves-effect waves-light m-b-40">Volver</a> </div>
        <footer class="footer text-center">© {{anho}} MPOSWEB.</footer>
    </div>
</section>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->
<!-- ============================================================== -->